import React, { useRef, useState } from 'react';
import { EAsociationType, FilterDTO, HeaderView, MATCH_MODES, Modal, createFiltersForMobile, setLoader, stringFilterTemplate, CustomTable, CustomTableRef } from 'medere-ui-framework';
import { useIntl } from 'react-intl';
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { useDispatch } from 'react-redux';
import { Toast, ToastMessage } from 'primereact/toast'
import { ManagerDTO, initialStateManagerDTO } from '../../interface/ManagerType';
import { useManagerService } from '../../servicesHooks/Manager/useManagerService';
import ManagerCard from '../../components/ManagerCard/ManagerCard';
import ManagerCrudPanel from './ManagerCrudPanel';

export default function PartnershipList() {
    const { deleteManager, loadManagers } = useManagerService();

    const tableRef = useRef<CustomTableRef>(null)    
    const [filterDTO, setFilterDTO] = useState<FilterDTO>({filters: [], associationType: EAsociationType.OR,filterLists:null });
    const intl = useIntl();
    const [confirmDialog, setConfirmDialog] = useState(false);
    const dispatch = useDispatch();
    const [manager, setManager] = useState<ManagerDTO>(initialStateManagerDTO);

    const [selectedMedereentity, setSelectedMedereentity] = useState<number | null>(null);

    const toast = useRef<any>(null)
    const showMessage = (ref: React.RefObject<Toast>, msg: any, severity: ToastMessage['severity']) => {
        ref.current?.show({ severity: severity, summary: msg, life: 3000 });
    };
    
    const handleEdit = (p:ManagerDTO) => {
      //navigate('../crud',{state:{medereentity:p.medereentity}})
      setSelectedMedereentity(p.medereentity);
    }

    const handleAdd = () => {
      //navigate('../crud',{state:{medereentity:p.medereentity}})
      setSelectedMedereentity(-1);
    }

    const onDelete = (p: ManagerDTO) => {
      deleteManager(p.medereentity).then((res:any)=>{
        if(res.status === 200){
          showMessage(toast, "Se ha eliminado exitosamente la gerenciadora", 'success')
          //dispatch(setNotification({title:"Se ha eliminado exitosamente la sociedad", typeOfNotification:ETypeOfNotification.INFO}))
          tableRef.current?.refreshTable?.();
        }
        else{
          let errorMessage = res.message || res.data.message;
          showMessage(toast, "Ha ocurrido un error al eliminar la gerenciadora: "+errorMessage, 'error')
          //dispatch(setNotification({title:"Ha ocurrido un error al eliminar la sociedad: "+errorMessage, typeOfNotification:ETypeOfNotification.ERROR}));
        }
      }).finally(() => {
        dispatch(setLoader(false));
      });
      setManager(initialStateManagerDTO);
    }

    const handleDelete = (p:ManagerDTO) => {
        setManager(p);
        setConfirmDialog(true);
    };
    

    const handleFilterChange = (newValue: string) => {
      let _filterDTO: FilterDTO = createFiltersForMobile(newValue,
        [{
          fieldName: "commercialname",
          filterType: MATCH_MODES.CONTAINS,
        },
        {
          fieldName: "businessname",
          filterType: MATCH_MODES.CONTAINS,
        },
        {
          fieldName: "document",
          filterType: MATCH_MODES.CONTAINS,
        }
        ]);
      // Actualizar el estado utilizando el setter original
      setFilterDTO(_filterDTO);
    }

    if (selectedMedereentity == null)
        return (//poner un if else con selectedMedereentity==null al momento de abrir o no el crud, para edit poner valor, para new poner -1
            <div className='viewContainer'>
              <div style={{height: '650px'}}>
                <HeaderView className='justify-content-between mr-3' title={"Gerenciadoras"} >
                  <Button className='buttonSecondary p-button-rounded' icon="pi pi-plus" onClick={()=>/*navigate("../crud")*/handleAdd()}></Button>
                </HeaderView>
                <CustomTable
                    idTable="partnershipTable"
                    className='ml-3.5 mr-3.5'
                    ref={tableRef}
                    getItems={loadManagers}
                    params={{cardFilterDTO:filterDTO || null , active: true}}
                    resizableColumns
                    notFoundText={intl.formatMessage({id:"NoResultsFound"})}
                    filterRow
                    rowButtonClassName="buttonSecondary2TableButtons"
                    CardTemplate={ManagerCard}
                    cardKeyName="medereentity"
                    cardEditBtn={{ className: 'buttonSecondary2', icon: 'pi-file-edit' }}
                    cardDeleteBtn={{ className: 'buttonSecondary2', icon: 'pi-trash' }}
                    handleMobileFilter={handleFilterChange}
                    buttonController
                    dropdownButton={{ edit: handleEdit, deleted: handleDelete }} 
                >
                    <Column key={"document"} field="document" header={"CUIT"} filter headerClassName="column" className="column" sortable filterElement={stringFilterTemplate} />
                    <Column key={"commercialname"} field="commercialname" header={intl.formatMessage({id:"Name"})} filter headerClassName="column" className="column" sortable filterElement={stringFilterTemplate} />
                    <Column key={"businessname"} field="businessname" header={"Nom. Fiscal"} filter headerClassName="column" className="column" sortable filterElement={stringFilterTemplate} />
                    <Column key={"entitystatedesc"} field="entitystatedesc" header={"Estado"} filter headerClassName="column" className="column" sortable filterElement={stringFilterTemplate} />
                    
                </CustomTable>
                <Modal
                    visible={confirmDialog}
                    setVisible={setConfirmDialog}
                    header={"¿Confirma eliminar la gerenciadora?"}
                    footerButtonRightText={intl.formatMessage({ id: "Yes" })}
                    footerButtonLeftText={intl.formatMessage({ id: "No" })}
                    onClickRightBtn={() => {
                    setConfirmDialog(false);
                    manager && manager.medereentity>-1 && onDelete(manager);
                    }}
                    onClickLeftBtn={() => { setConfirmDialog(false); }} />
              </div>
            </div>
        )
    else
        return (
            <ManagerCrudPanel medereentity={selectedMedereentity} setMedereentity={setSelectedMedereentity}/>
        )
}
